module.exports = __webpack_public_path__ + "img/payme_logo_color_oneline.06fd9045.png";